require('./cardSecurePaymentStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { FormattedText, formatText} = require('core/i18n').i18n;
const { nonNumericFilter } = require('utilities/stringHelper');
const { formatCardNumber } = require('utilities/cardsHelper');
// @ components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ constants
const {CARD_SECURE_PAYMENT_ID} = require('constants/operationTypes');
const { ECOMMERCE_KEY, ECOMMERCE_INTERNET_PAYMENTS_ADHERED } = require('constants/flagBasedFeatures');

class CardSecurePaymentStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { immCard, immFirstStep, immFlagBasedFeatures } = this.props;
        const isSecureCommerceChecked = !!immFirstStep.get('isSecureCommerceChecked');
        const isNoSecureCommerceChecked = !!immFirstStep.get('isNoSecureCommerceChecked');
        let secondStepTextKey;

        if (immFlagBasedFeatures.get(ECOMMERCE_INTERNET_PAYMENTS_ADHERED) && immFlagBasedFeatures.get(ECOMMERCE_KEY)) {
            if (isNoSecureCommerceChecked) {
                secondStepTextKey = 'cardSecurePayment-cardSecurePayment_secondStepNoCESTextPaymentAllowed';
            } else {
                secondStepTextKey = 'cardSecurePayment-cardSecurePayment_secondStepNoCESTextPaymentNotAllowed';
            }
        } else {
            if (isSecureCommerceChecked && isNoSecureCommerceChecked) {
                secondStepTextKey = 'cardSecurePayment-secondStepBoothSelectedText';
            } else if (isSecureCommerceChecked) {
                secondStepTextKey = 'cardSecurePayment-secondStepCESSelectedText';
            } else if (isNoSecureCommerceChecked) {
                secondStepTextKey = 'cardSecurePayment-secondStepNoCESSelectedText';
            } else {
                secondStepTextKey = 'cardSecurePayment-secondStepNoSelectedText';
            }
        }

        const operative = formatText('operatives-cardSecurePayment');

        return (
            <div className="card-secure-payment-step-two">
                <header className="card-secure-payment-step-two__header print-title">
                    <FormattedText value="cardSecurePayment-secondStepTitle" />
                </header>
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={operative}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
                <article className="card-secure-payment-step-two__content">
                    <FormattedText value={secondStepTextKey} injectedStrings={[ formatCardNumber(immCard.get('number'), 4, '*') ]} className="card-secure-payment-step-two__text"/>
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    <SignaturePattern
                        operationType={CARD_SECURE_PAYMENT_ID}
                        operationParams={{pan: nonNumericFilter(immCard.get('number'))}}
                    />


                </article>
            </div>
        );
    }
}

CardSecurePaymentStep2.propTypes = {
    immCard: PropTypes.object,
    immFirstStep: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = CardSecurePaymentStep2;